module.exports = __webpack_public_path__ + "static/media/s5.02b99987.svg";